import { StreamActions, renderStreamMessage } from "@hotwired/turbo"

// Custom Turbo Stream action: <turbo-stream action="fetch" target="element-id">
// Finds the target element, reads its data-fetch-url, fetches it as turbo_stream,
// and applies the response. Generic - any element with data-fetch-url is fetchable.
//
// View:
//   div id="snap-2026-03-29" data-fetch-url="/nutrition/meals/day/2026-03-29"
//
// Model:
//   Turbo::StreamsChannel.broadcast_action_to(user, :snap, action: "fetch", target: "snap-2026-03-29")
StreamActions.fetch = function () {
  const target = document.getElementById(this.target)
  if (!target) return

  const url = target.dataset.fetchUrl
  if (!url) return

  fetch(url, { headers: { Accept: "text/vnd.turbo-stream.html" } })
    .then(r => r.text())
    .then(html => renderStreamMessage(html))
}
